export default "__VITE_ASSET__C6YrwX7c__"